// Unified Auth0 wrapper that switches between real and mock based on environment
const USE_MOCK_AUTH = process.env.REACT_APP_USE_MOCK_AUTH === "true";

if (USE_MOCK_AUTH) {
  module.exports = require("./mock-auth0-wrapper");
} else {
  module.exports = require("./react-auth0-wrapper");
}
